import { Intercom } from '../components';

export const IntercomPage = () => <Intercom forceOpen />;

export default IntercomPage;
